/**
 * Registro imperativo de "intenciones de CUE" para comunicar tiempo de inicio
 * entre PeticionAudioProgress (que dispara el CUE) y el handler del botón Play
 * en SortablePeticionItem (que carga el <audio> perezosamente).
 *
 * Uso:
 *  - `setCueIntent(audioFileId, timeSec)` justo antes de simular click en Play.
 *  - `takeCueIntent(audioFileId)` dentro del handler de Play, antes de audio.play().
 *    Devuelve el tiempo y borra la entrada (consumo one-shot). Retorna
 *    `undefined` si no hay intención o si expiró (>60s desde que se guardó).
 */
const intents = new Map();

export const setCueIntent = (audioFileId, timeSec) => {
  if (!audioFileId) return;
  intents.set(audioFileId, { time: Number(timeSec) || 0, ts: Date.now() });
};

export const takeCueIntent = (audioFileId) => {
  const entry = intents.get(audioFileId);
  if (!entry) return undefined;
  intents.delete(audioFileId);
  // Safety: descarta intenciones antiguas por si el usuario cambió de idea
  if (Date.now() - entry.ts > 60000) return undefined;
  return entry.time;
};

export const hasCueIntent = (audioFileId) => intents.has(audioFileId);
